import { API_ROUTES_FOR_AXIOS } from 'src/constants/ApiRoutes';
import { axiosInstance } from 'src/constants/axiosInstance';
import { ApiResponse } from 'src/types/commonResponseTypes';
import {
  ActivationGetStartedResponse,
  ActivationRecommendationsResponse,
  ActivationTrackPayload,
} from 'src/types/activation';
import { handleError } from 'src/utils/commonErrorUtils';

export const getActivationGetStarted = async (options?: {
  includeWorkspaceState?: boolean;
}): Promise<ApiResponse<ActivationGetStartedResponse>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS.getActivationGetStarted(
      options?.includeWorkspaceState,
    );
    const { data } = await axiosInstance.get(apiUrl);

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const getActivationRecommendations = async (): Promise<
  ApiResponse<ActivationRecommendationsResponse>
> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS.getActivationRecommendations();
    const { data } = await axiosInstance.get(apiUrl, {
      skipUnauthorizedLogout: true,
    });

    return data;
  } catch (error) {
    return handleError(error);
  }
};

export const trackActivationEvent = async (
  body: ActivationTrackPayload,
): Promise<ApiResponse<string>> => {
  try {
    const apiUrl = API_ROUTES_FOR_AXIOS.trackActivationEvent();
    const { data } = await axiosInstance.post(apiUrl, body, {
      skipUnauthorizedLogout: true,
    });

    return data;
  } catch (error) {
    return handleError(error);
  }
};
